
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/security/[page]",
      function () {
        return require("private-next-pages/security/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/security/[page]"])
      });
    }
  